import { Stack } from '@mui/material';

import { MINI_SIDE_BAR } from '@src/layouts/configs';

import SiderBarMiniContent from '../components/side-bar-mini-content';

const SideBarMini = () => {
  const content = <SiderBarMiniContent />;

  return (
    <Stack
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: MINI_SIDE_BAR.WIDTH,
      }}
    >
      <Stack
        sx={{
          height: 1,
          width: MINI_SIDE_BAR.WIDTH,
          borderRight: (theme) => `1px solid ${theme.palette.custom.darkGrey}`,
        }}
      >
        {content}
      </Stack>
    </Stack>
  );
};

export default SideBarMini;
